/**
 * VenueFilters Component
 * Provides filter controls for the RTP Venues page including:
 * - ID (text input)
 * - Name (text input)
 * - City (text input)
 * - State (text input)
 * - Status (select dropdown)
 * - Verification Status (select dropdown)
 * - Layout Type (select dropdown)
 */

import { FilterControl, FilterChoice, DefaultVenueFilters } from '../types';

/**
 * Defines the filter controls configuration for venue filtering
 * @returns {FilterControl[]} Array of filter control configurations
 */
export const getVenueFilterControls = (): FilterControl[] => {
    // Status options for filtering venues (0 = Inactive, 1 = Active)
    const statusOptions: FilterChoice[] = [
        { id: 1, name: 'Active' },
        { id: 0, name: 'Inactive' }
    ];

    // Status options for filtering
    const verificationStatusOptions: FilterChoice[] = [
        { id: 1, name: 'Whitelist' },
        { id: 2, name: 'Blacklist' },
    ];

    // Layout type options for filtering venues
    const layoutTypeOptions: FilterChoice[] = [
        { id: 'standard', name: 'Standard' },
        { id: 'horseshoe', name: 'Horseshoe' },
        { id: 'table', name: 'Table' },
        { id: 'other', name: 'Other' }
    ];

    return [
        { component: 'number', name: 'id_eq', label: 'ID', xs: 1 },
        { component: 'text', name: 'name_contains', label: 'Name', xs: 2 },
        { component: 'text', name: 'city_contains', label: 'City', xs: 1.5 },
        { component: 'text', name: 'state_contains', label: 'State', xs: 1 },
        { component: 'select', name: 'status_eq', label: 'Status', choices: statusOptions, xs: 1.5 },
        { component: 'select', name: 'verification_status_eq', label: 'Verification', choices: verificationStatusOptions, xs: 1.5 },
        { component: 'select', name: 'layout_type_eq', label: 'Layout Type', choices: layoutTypeOptions, xs: 1.5 }
    ];
};

/**
 * Returns the default filter values for the venue page
 * Sets status = 1 (Active) and verification_status = 1 (Whitelist) as default filters
 * @returns {DefaultVenueFilters} Default filter values with proper typing
 */
export const getDefaultVenueFilters = (): DefaultVenueFilters => {
    return {
        status_eq: 1, // Default to showing active venues (status = 1)
        verification_status_eq: 1 // Default to showing whitelisted venues (verification_status = 1)
    };
};